import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { ConnectedLocationItem } from './LocationItem';
import { LocationProp, LocationType, LegTypeProps, SourceOptionsType, GeoType, TabType, TabTypeProp, TabTypePropDefault } from '../../models';

export class LocationsList extends PureComponent {
    state = {
        locations: this.getLocations(),
        selectedLocation: 0,
    };

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentDidUpdate(prevProps) {
        const { suggestionsList } = this.props;
        if (prevProps.suggestionsList !== suggestionsList) {
            this.setState({
                locations: this.getLocations(),
                selectedLocation: 0,
            });
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    getLocations() {
        const { suggestionsList } = this.props;
        const locations = [];
        suggestionsList.forEach((location) => {
            if (this.shouldDisplayParentLocation(location)) {
                locations.push({ value: location });
            }
            const relatedLocations = this.getRelatedLocations(location);
            relatedLocations.forEach((related) => {
                locations.push({ value: related, parentLocation: location });
            });
        });
        return locations;
    }

    getLocationItemKey(location) {
        const { activeProduct } = this.props;
        const { parentLocation, value } = location;
        const { geoNodeId, id, type } = value;
        const itemKey =
            activeProduct === TabType.HOTELS && (type === LocationType.HOTEL || Object.values(GeoType).includes(type))
                ? id
                : geoNodeId;
        return !isEmpty(parentLocation)
            ? `r-${parentLocation.geoNodeId}-${itemKey}`
            : `l-${itemKey}`;
    }

    getRelatedLocations(location) {
        const hasRelatedLocations =
            location.relatedLocations?.length > 1 || location.type === LocationType.NEAREST;
        return hasRelatedLocations ? location.relatedLocations : [];
    }

    handleKeyDown = (e) => {
        const key = e.keyCode || e.key;

        if (key === 'ArrowDown' || key === 40) {
            e.preventDefault();
            this.handleArrowDown(e);
        } else if (key === 'ArrowUp' || key === 38) {
            e.preventDefault();
            this.handleArrowUp();
        } else if (key === 'Enter' || key === 13) {
            e.target.blur();
            this.handleEnter();
        } else if (key === 'Tab' || key === 9) {
            e.preventDefault();
            e.target.blur();
            this.handleTab();
        }
    };

    handleTab() {
        const { locations, selectedLocation } = this.state;
        this.props.onClickItem(locations[selectedLocation].value);
    }

    handleEnter() {
        const { locations, selectedLocation } = this.state;
        this.props.onClickItem(locations[selectedLocation].value);
    }

    handleArrowUp() {
        const { selectedLocation } = this.state;
        if (selectedLocation > 0) {
            this.setState({
                selectedLocation: selectedLocation - 1,
            });
        }
    }

    handleArrowDown() {
        const { locations, selectedLocation } = this.state;
        if (selectedLocation < locations.length - 1) {
            this.setState({
                selectedLocation: selectedLocation + 1,
            });
        }
    }

    shouldDisplayParentLocation(location) {
        return location.type !== LocationType.NEAREST;
    }

    render() {
        const { onClickItem, displayedWord, departureOrArrival, isFixedWidth } = this.props;
        const { locations, selectedLocation } = this.state;
        return (
            <React.Fragment>
                {locations.map((location, index) => (
                    <ConnectedLocationItem
                        key={this.getLocationItemKey(location)}
                        parentLocation={location.parentLocation || null}
                        location={location.value}
                        onClickItem={onClickItem}
                        isSelected={index === selectedLocation}
                        displayedWord={displayedWord}
                        departureOrArrival={departureOrArrival}
                        isFixedWidth={isFixedWidth}
                    />
                ))}
            </React.Fragment>
        );
    }
}

LocationsList.propTypes = {
    ...SourceOptionsType,
    suggestionsList: PropTypes.arrayOf(LocationProp).isRequired,
    departureOrArrival: LegTypeProps.isRequired,
    activeProduct: TabTypeProp,
};

LocationsList.defaultProps = {
    activeProduct: TabTypePropDefault,
};

const mapStateToProps = ({ activeProduct }) => ({
    activeProduct: activeProduct.activeProduct,
});

export const ConnectedLocationsList = connect(mapStateToProps, {})(LocationsList);
